module.exports = __webpack_public_path__ + "static/img/banner_button.82c77e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_button.png
// module id = TYbk
// module chunks = 1